import { Injectable } from '@angular/core';

import { environment } from '@hm/environments/environment';

import { PartnersService as CorePartnersService } from '@lib/core/services/partners.service';

@Injectable({ providedIn: 'root' })
export class PartnersService extends CorePartnersService {
  constructor() {
    super(environment.protectedApiUrl);
  }
}
